module.exports = __webpack_public_path__ + "img/google-play.4171701e.png";